import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { BottomSheetSelectorComponent } from 'cloud-shared-lib';
import { ComponentsModule } from '../../components/components.module';
import { CutoutsCreatorComponent } from '../../components/cutouts-creator/cutouts-creator.component';
import { StandardCutoutSelectComponent } from '../../components/standard-cutout-select/standard-cutout-select.component';
import { DirectivesModule } from '../../directives/directives.module';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { MaxNumberPrecisionDirective } from '../../validators/max-number-precision.validator';
import { AngleSettingsModule } from '../angle-settings/angle-setting.module';
import { CustomFormsModule } from '../custom-forms/custom-forms.module';
import { CuttingMaterialBaseDialogModule } from '../cutting-material-base-dialog/public-api';
import { FastenersWizardDialogModule } from '../fasteners-wizard-dialog/fasteners-wizard-dialog.module';
import { MaterialBaseButtsDialogModule } from '../material-base-butts-dialog/material-base-butts-dialog.module';
import { MdePopoverModule } from '../popover/popover.module';
import { SlotsDialogModule } from '../slots-dialog/slots-dialog.module';
import { ClientPanelListService } from './client-panel-list.resolver';
import { CuttingPanelListService } from './cutting-panel-list.service';
import { FaceBandingReplacementCustomDialogComponent } from './face-banding-replacement-custom-dialog/face-banding-replacement-custom-dialog.component';
import { FieldSettingsComponent } from './field-settings/field-settings.component';
import { ImportFromCsvDialogComponent } from './import-from-csv-dialog/import-from-csv-dialog.component';
import { PanelListDataService } from './panel-list-data.service';
import { PanelListV2Component } from './panel-list-v2.component';
import { PanelListComponent } from './panel-list.component';
import { PanelMirroringDialogComponent } from './panel-mirroring-dialog/panel-mirroring-dialog.component';
import { AngleFormComponent } from './panel-outline-editor-dialog/angle-form/angle-form.component';
import { ButtForAllSidesBottomSheetComponent } from './panel-outline-editor-dialog/butt-form/butt-for-all-sides-bottom-sheet/butt-for-all-sides-bottom-sheet.component';
import { ButtFormComponent } from './panel-outline-editor-dialog/butt-form/butt-form.component';
import { FaceBandingComponent } from './panel-outline-editor-dialog/face-banding/face-banding.component';
import { CustomFastenersComponent } from './panel-outline-editor-dialog/fasteners-form/custom/custom-fasteners.component';
import { FastenersFormComponent } from './panel-outline-editor-dialog/fasteners-form/fasteners-form.component';
import { GrooveFormComponent } from './panel-outline-editor-dialog/groove-form/groove-form.component';
import { GroovePlateSelectorComponent } from './panel-outline-editor-dialog/groove-form/groove-plate-selector/groove-plate-selector.component';
import { GrooveInfoComponent } from './panel-outline-editor-dialog/groove-form/groove-select/groove-info/groove-info.component';
import { GrooveSelectComponent } from './panel-outline-editor-dialog/groove-form/groove-select/groove-select.component';
import { PanelOutlineEditorDialogComponent } from './panel-outline-editor-dialog/panel-outline-editor-dialog.component';
import { PlateCutoutFormComponent } from './panel-outline-editor-dialog/plate-cutout-form/plate-cutout-form.component';
import { PlateCutoutListComponent } from './panel-outline-editor-dialog/plate-cutout-form/plate-cutout-list/plate-cutout-list.component';
import { CutoutAdderComponent } from './panel-outline-editor-dialog/plate-cutout-form/plate-cutout-wizard-dialog/cutout-adder/cutout-adder.component';
import { PlateCutoutWizardDialogComponent } from './panel-outline-editor-dialog/plate-cutout-form/plate-cutout-wizard-dialog/plate-cutout-wizard-dialog.component';
import { StandardCutoutsComponent } from './panel-outline-editor-dialog/plate-cutout-form/plate-cutout-wizard-dialog/standard-cutouts/standard-cutouts.component';
import { UserPanelListService } from './user-panel-list.resolver';

@NgModule({
  imports: [
    CommonModule, //
    FormsModule,
    CustomFormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FastenersWizardDialogModule,
    AngleSettingsModule,
    SlotsDialogModule,
    CuttingMaterialBaseDialogModule,
    MaterialBaseButtsDialogModule,
    StandardCutoutSelectComponent,
    CutoutsCreatorComponent,
    MatLegacySnackBarModule,

    ComponentsModule,
    DirectivesModule,

    MdePopoverModule,

    MatIconModule,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTabsModule,
    MatButtonModule,
    MatTableModule,
    CdkTableModule,
    MatPaginatorModule,
    MatListModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDialogModule,
    MatSortModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDividerModule,
    MatToolbarModule,
    MatCardModule,
    MatBottomSheetModule,
    MatStepperModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatLegacyDialogModule,
    GrooveInfoComponent,
    BottomSheetSelectorComponent,
  ],
  declarations: [
    PanelListComponent, //
    PanelListV2Component,
    ImportFromCsvDialogComponent,
    FieldSettingsComponent,
    PanelMirroringDialogComponent,

    MaxNumberPrecisionDirective,

    PanelOutlineEditorDialogComponent,
    AngleFormComponent,
    ButtFormComponent,
    GrooveFormComponent,
    GrooveSelectComponent,
    ButtForAllSidesBottomSheetComponent,
    FastenersFormComponent,
    FaceBandingComponent,
    CustomFastenersComponent,
    GroovePlateSelectorComponent,
    PlateCutoutFormComponent,
    PlateCutoutWizardDialogComponent,
    PlateCutoutListComponent,
    StandardCutoutsComponent,
    CutoutAdderComponent,
    FaceBandingReplacementCustomDialogComponent,
  ],
  providers: [CuttingPanelListService, CuttingButtFormService, ClientPanelListService, UserPanelListService],
  exports: [PanelListComponent, PanelListV2Component],
})
export class CuttingPanelListModule {
  static forRoot<T extends PanelListDataService>(dataProvider: Type<T>): ModuleWithProviders<CuttingPanelListModule> {
    return {
      ngModule: CuttingPanelListModule,
      providers: [
        {
          provide: PanelListDataService,
          useClass: dataProvider,
        },
      ],
    };
  }
}
